// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"09fd37b0","796":"a43b3ef0"}[chunkId] + ".chunk.js";
};